import { CaretDownIcon, XIcon } from '@phosphor-icons/react';

interface SourceStatusDrawerHeaderProps {
    title: string;
    isExpanded: boolean;
    allComplete: boolean;
    onToggleExpanded: () => void;
    onClose: () => void;
}

export function SourceStatusDrawerHeader({
    title,
    isExpanded,
    allComplete,
    onToggleExpanded,
    onClose,
}: SourceStatusDrawerHeaderProps) {
    return (
        <div className="flex items-center justify-between p-4 border-b border-grey-600">
            <span className="text-sm font-medium text-white">{title}</span>

            <div className="flex items-center gap-2">
                <button
                    onClick={onToggleExpanded}
                    className="text-grey-200 hover:text-white transition-colors"
                >
                    <CaretDownIcon
                        className={`w-5 h-5 transition-transform ${isExpanded ? '' : 'rotate-180'}`}
                    />
                </button>

                {allComplete && (
                    <button
                        onClick={onClose}
                        className="text-grey-200 hover:text-white transition-colors"
                    >
                        <XIcon className="w-5 h-5" />
                    </button>
                )}
            </div>
        </div>
    );
}
